import { render, staticRenderFns } from "./TheBackground.vue?vue&type=template&id=1bfc4c0d&scoped=true&"
var script = {}
import style0 from "./TheBackground.vue?vue&type=style&index=0&id=1bfc4c0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc4c0d",
  null
  
)

export default component.exports